module.exports = __webpack_public_path__ + "ioc-liturgical-react-logo.0043647f.png";


//////////////////
// WEBPACK FOOTER
// ./demo/src/images/ioc-liturgical-react-logo.png
// module id = m6Am
// module chunks = 0